'use strict';

/* Kalis Media 2021
 * To use this module add following line to theme.liquid, just before </body> tag
 * <script src="//lokk.no/cdn/shop/t/28/assets/kalis-teams-menu-desktop.js?v=105670161072781185801792870200" defer="defer"></script>
 *
 * To work this script needs a specific Impulse theme setup
 * Four main menu links are set: MLB, NBA, NFL, NHL, all on the third mega menu level
 * Below those links all the links "under" with team names are set on the same level
 * This script hides all team links, but not those four special links
 * When hovering over a special link it shows those themes
 */

// window.addEventListener('load', function() {

(function init() {
  (function init() {
    var data = {
      MLB: {
        main: $('.megamenu .grid a[href*="/collections/mlb"]'),
        teams: findLinksByString(' - MLB')
      },
      NBA: {
        main: $('.megamenu .grid a[href*="/collections/nba"]'),
        teams: findLinksByString(' - NBA')
      },
      NFL: {
        main: $('.megamenu .grid a[href*="/collections/nfl"]'),
        teams: findLinksByString(' - NFL')
      },
      NHL: {
        main: $('.megamenu .grid a[href*="/collections/nhl"]'),
        teams: findLinksByString(' - NHL')
      }
    };

    hideTeams(data);

    onHoverShow(data);
  })();

  function findLinksByString(search) {
    var results = $();
    var links = $('.megamenu .grid a');

    // img
    $.each(links, function(index, link) {
      var alt = $(link).find('img').attr('alt');
      if (alt && alt.indexOf(search) !== -1) {
        results = results.add($(link));
      }
    });

    // title
    $.each(links, function(index, link) {
      var text = $(link).text();
      if (text && text.indexOf(search) !== -1) {
        $(link).text(text.split(search).join('')); // remove " - NHL" from titles
        results = results.add($(link));
      }
    });

    return results;
  }

  function hideTeams(data) {
    data.MLB.teams.removeClass('show-team');
    data.MLB.teams.addClass('hide-team');

    data.NBA.teams.removeClass('show-team');
    data.NBA.teams.addClass('hide-team');

    data.NFL.teams.removeClass('show-team');
    data.NFL.teams.addClass('hide-team');

    data.NHL.teams.removeClass('show-team');
    data.NHL.teams.addClass('hide-team');
  }

  function onHoverShow(data) {
    data.MLB.main.on('mouseover', function() {
      hideTeams(data)
      data.MLB.teams.removeClass('hide-team');
      data.MLB.teams.addClass('show-team');
      highlightMain(data, data.MLB.main);
    });

    data.NBA.main.on('mouseover', function() {
      hideTeams(data)
      data.NBA.teams.removeClass('hide-team');
      data.NBA.teams.addClass('show-team');
      highlightMain(data, data.NBA.main);
    });

    data.NFL.main.on('mouseover', function() {
      hideTeams(data)
      data.NFL.teams.removeClass('hide-team');
      data.NFL.teams.addClass('show-team');
      highlightMain(data, data.NFL.main);
    });

    data.NHL.main.on('mouseover', function() {
      hideTeams(data)
      data.NHL.teams.removeClass('hide-team');
      data.NHL.teams.addClass('show-team');
      highlightMain(data, data.NHL.main);
    });
  }

  function highlightMain(data, mainToHighlight) {
    data.MLB.main.find('img').css('opacity', '0.4');
    data.NBA.main.find('img').css('opacity', '0.4');
    data.NFL.main.find('img').css('opacity', '0.4');
    data.NHL.main.find('img').css('opacity', '0.4');
    mainToHighlight.find('img').css('opacity', '1');
  }
})();
